import { Component, Input, Output, EventEmitter, ElementRef, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NpnSliderComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.currentValues[ctx_r0.handlerIndex.left]);
} }
function NpnSliderComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const stepPos_r6 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("left", stepPos_r6, "px");
} }
function NpnSliderComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("left", ctx_r2.handlerX[0], "%")("width", ctx_r2.handlerX[ctx_r2.handlerIndex.right] - ctx_r2.handlerX[ctx_r2.handlerIndex.left], "%");
} }
function NpnSliderComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("left", 0, "%")("width", ctx_r3.handlerX[0], "%");
} }
function NpnSliderComponent_span_9_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.currentValues[ctx_r7.handlerIndex.right]);
} }
const _c0 = function (a0, a1) { return { "active": a0, "last-active": a1 }; };
function NpnSliderComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("mousedown", function NpnSliderComponent_span_9_Template_span_mousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.setHandlerActive($event, ctx_r8.handlerIndex.right); })("panstart", function NpnSliderComponent_span_9_Template_span_panstart_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.setHandlerActive($event, ctx_r10.handlerIndex.right); });
    ɵngcc0.ɵɵtemplate(1, NpnSliderComponent_span_9_span_1_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("left", ctx_r4.handlerX[ctx_r4.handlerIndex.right], "%");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c0, ctx_r4.isHandlerActive && ctx_r4.currentHandlerIndex === ctx_r4.handlerIndex.right, ctx_r4.currentHandlerIndex === ctx_r4.handlerIndex.right));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.hideTooltip);
} }
function NpnSliderComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.initValues[ctx_r5.handlerIndex.left]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.initValues[ctx_r5.handlerIndex.right]);
} }
class Utilities {
    /**
     * @param {?} arr
     * @return {?}
     */
    isNumberArray(arr) {
        return (arr && arr.length && arr.filter((value) => !isNaN(value)).length === arr.length) ? true : false;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    isNullOrEmpty(obj) {
        return obj === undefined || obj === null || obj === '';
    }
    /**
     * @param {?} obj
     * @param {...?} allowedValues
     * @return {?}
     */
    toBoolean(obj, ...allowedValues) {
        return (obj === '' || obj === 'true' || allowedValues.indexOf(obj) !== -1) ? true : false;
    }
    /**
     * @param {?} n
     * @param {?} step
     * @return {?}
     */
    findNextValidStepValue(n, step) {
        const /** @type {?} */ divisorsSet1 = [];
        const /** @type {?} */ divisorsSet2 = [];
        const /** @type {?} */ sqrtNum = Math.sqrt(n);
        let /** @type {?} */ newStep = -1;
        for (let /** @type {?} */ i = 0; i < sqrtNum; i++) {
            if (n % i === 0) {
                if ((n / i) === i) {
                    divisorsSet1.push(i);
                }
                else {
                    divisorsSet1.push(i);
                    divisorsSet2.push(n / i);
                }
            }
        }
        // Picking newStep by checking large set of divisors first
        for (let /** @type {?} */ i = 0; i < divisorsSet2.length; i++) {
            if (step > divisorsSet2[i]) {
                newStep = divisorsSet2[i];
                break;
            }
        }
        if (newStep === -1) {
            // checking set of small divisors if newStep didn't find out till.
            for (let /** @type {?} */ i = divisorsSet1.length - 1; i >= 0; i--) {
                if (step > divisorsSet1[i]) {
                    newStep = divisorsSet1[i];
                    break;
                }
            }
        }
        return (newStep === -1) ? 1 : newStep;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
const SliderHandlerEnum = {
    left: 0,
    right: 1,
};
SliderHandlerEnum[SliderHandlerEnum.left] = "left";
SliderHandlerEnum[SliderHandlerEnum.right] = "right";

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NpnSliderComponent extends Utilities {
    /**
     * @param {?} el
     */
    constructor(el) {
        super();
        this.el = el;
        this.sliderModel = [0, 0, 0];
        this.step = 1;
        this.sliderWidth = 0;
        this.totalDiff = 0;
        this.startClientX = 0;
        this.startPleft = 0;
        this.startPRight = 0;
        this.sliderInitiated = false;
        this.initValues = [];
        this.currentValues = [0, 0];
        this.handlerX = [0, 0];
        this.isHandlerActive = false;
        this.isTouchEventStart = false;
        this.isMouseEventStart = false;
        this.currentHandlerIndex = 0;
        this.stepIndicatorPositions = [];
        this.isDisabled = false;
        this.hideTooltip = false;
        this.hideValues = false;
        this.handlerIndex = SliderHandlerEnum;
        this.showStepIndicator = false;
        this.multiRange = true;
        this.onChange = new EventEmitter();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setMinValues(value) {
        if (!isNaN(value)) {
            this.minValue = Number(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setMaxValues(value) {
        if (!isNaN(value)) {
            this.maxValue = Number(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setMinSelectedValues(value) {
        if (!isNaN(value) && this.minSelected !== Number(value)) {
            this.minSelected = Number(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setMaxSelectedValues(value) {
        if (!isNaN(value) && this.maxSelected !== Number(value)) {
            this.maxSelected = Number(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set stepValue(value) {
        if (!isNaN(value)) {
            this.step = Number(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setHideTooltip(value) {
        this.hideTooltip = this.toBoolean(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setHideValues(value) {
        this.hideValues = this.toBoolean(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set setDisabled(value) {
        this.isDisabled = this.toBoolean(value, 'disabled');
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.initializeSlider();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.sliderInitiated) {
            if (!this.isNullOrEmpty(changes["setMinSelectedValues"])
                && changes["setMinSelectedValues"].previousValue === changes["setMinSelectedValues"].currentValue) {
                return;
            }
            if (!this.isNullOrEmpty(changes["setMaxSelectedValues"])
                && changes["setMaxSelectedValues"].previousValue === changes["setMaxSelectedValues"].currentValue) {
                return;
            }
            this.resetModel();
        }
    }
    /**
     * @return {?}
     */
    initializeSlider() {
        try {
            // Taking width of slider bar element.
            this.sliderWidth = this.el.nativeElement.children[0].children[0].offsetWidth;
            this.resetModel();
            this.sliderInitiated = true;
        }
        catch (/** @type {?} */ e) {
            console.error(e);
        }
    }
    /**
     * @return {?}
     */
    resetModel() {
        this.validateSliderValues();
        // Setting the model values
        this.sliderModel = [
            this.currentValues[0] - this.initValues[0],
            this.currentValues[1] - this.currentValues[0],
            this.initValues[1] - this.currentValues[1]
        ];
        this.totalDiff = this.sliderModel.reduce((prevValue, curValue) => prevValue + curValue, 0);
        // Validation for slider step
        if (this.totalDiff % this.step !== 0) {
            const /** @type {?} */ newStep = this.findNextValidStepValue(this.totalDiff, this.step);
            console.warn('Invalid step value "' + this.step + '" : and took "' + newStep + '" as default step');
            this.step = newStep;
        }
        this.initializeStepIndicator();
        this.setHandlerPosition();
    }
    /**
     * @return {?}
     */
    validateSliderValues() {
        if (this.isNullOrEmpty(this.minValue) || this.isNullOrEmpty(this.maxValue)) {
            this.updateInitValues([0, 0]);
            this.updateCurrentValue([0, 0], true);
        }
        else if (this.minValue > this.maxValue) {
            this.updateInitValues([0, 0]);
            this.updateCurrentValue([0, 0], true);
        }
        else {
            this.initValues = [this.minValue, this.maxValue];
            /*
                  * Validation for Selected range values
                  */
            if (this.isNullOrEmpty(this.minSelected) || this.minSelected < this.minValue || this.minSelected > this.maxValue) {
                this.minSelected = this.minValue;
            }
            if (this.isNullOrEmpty(this.maxSelected) || this.maxSelected < this.minValue || this.maxSelected > this.maxValue) {
                this.maxSelected = this.maxValue;
            }
            if (this.minSelected > this.maxSelected) {
                this.minSelected = this.minValue;
                this.maxSelected = this.maxValue;
            }
            this.updateCurrentValue([this.minSelected, this.maxSelected], true);
        }
    }
    /**
     * @return {?}
     */
    initializeStepIndicator() {
        if (this.showStepIndicator) {
            this.stepIndicatorPositions.length = 0;
            const /** @type {?} */ numOfStepIndicators = this.totalDiff / this.step;
            if (this.sliderWidth / numOfStepIndicators >= 10) {
                const /** @type {?} */ increment = this.sliderWidth / numOfStepIndicators;
                let /** @type {?} */ leftPosition = increment;
                while (this.stepIndicatorPositions.length < numOfStepIndicators - 1) {
                    this.stepIndicatorPositions.push(+leftPosition.toFixed(2));
                    leftPosition += increment;
                }
            }
            else {
                console.warn(`As 'step' value is too small compared to min & max value difference and slider width,
          Step Indicator can't be displayed!. Provide slight large value for 'step'`);
            }
        }
        else {
            this.stepIndicatorPositions.length = 0;
        }
    }
    /**
     * @param {?} arrayValue
     * @param {?=} privateChange
     * @return {?}
     */
    updateCurrentValue(arrayValue, privateChange = false) {
        this.minSelected = this.currentValues[0] = arrayValue[0];
        this.maxSelected = this.currentValues[1] = arrayValue[1];
        if (!privateChange) {
            this.onChange.emit((this.multiRange) ? this.currentValues : [this.currentValues[0]]);
        }
    }
    /**
     * @param {?} arrayValue
     * @return {?}
     */
    updateInitValues(arrayValue) {
        this.minValue = this.initValues[0] = arrayValue[0];
        this.maxValue = this.initValues[1] = arrayValue[1];
    }
    /**
     * @return {?}
     */
    setHandlerPosition() {
        let /** @type {?} */ runningTotal = 0;
        // Updating selected values : current values
        this.updateCurrentValue([
            this.initValues[0] + this.sliderModel[0],
            this.initValues[1] - this.sliderModel[2]
        ]);
        /*Setting handler position */
        for (let /** @type {?} */ i = 0, /** @type {?} */ len = this.sliderModel.length - 1; i < len; i++) {
            runningTotal += this.sliderModel[i];
            this.handlerX[i] = (runningTotal / this.totalDiff) * 100;
        }
    }
    /**
     * @param {?} index
     * @param {?} value
     * @return {?}
     */
    setModelValue(index, value) {
        if (this.step > 1) {
            value = Math.round(value / this.step) * this.step;
        }
        this.sliderModel[index] = value;
    }
    /**
     * @return {?}
     */
    setHandlerActiveOff() {
        this.isMouseEventStart = false;
        this.isTouchEventStart = false;
        this.isHandlerActive = false;
    }
    /**
     * @param {?} event
     * @param {?} handlerIndex
     * @return {?}
     */
    setHandlerActive(event, handlerIndex) {
        event.preventDefault();
        if (!this.isDisabled) {
            if (!this.isNullOrEmpty(event.clientX)) {
                this.startClientX = event.clientX;
                this.isMouseEventStart = true;
                this.isTouchEventStart = false;
            }
            else if (!this.isNullOrEmpty(event.deltaX)) {
                this.startClientX = event.deltaX;
                this.isTouchEventStart = true;
                this.isMouseEventStart = false;
            }
            if (this.isMouseEventStart || this.isTouchEventStart) {
                this.currentHandlerIndex = handlerIndex;
                this.startPleft = this.sliderModel[handlerIndex];
                this.startPRight = this.sliderModel[handlerIndex + 1];
                this.isHandlerActive = true;
            }
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handlerSliding(event) {
        if ((this.isMouseEventStart && event.clientX) || (this.isTouchEventStart && event.deltaX)) {
            const /** @type {?} */ movedX = Math.round(((event.clientX || event.deltaX) - this.startClientX) / this.sliderWidth * this.totalDiff);
            const /** @type {?} */ nextPLeft = this.startPleft + movedX;
            const /** @type {?} */ nextPRight = this.startPRight - movedX;
            if (nextPLeft >= 0 && nextPRight >= 0) {
                this.setModelValue(this.currentHandlerIndex, nextPLeft);
                this.setModelValue(this.currentHandlerIndex + 1, nextPRight);
                this.setHandlerPosition();
            }
        }
    }
}
NpnSliderComponent.ɵfac = function NpnSliderComponent_Factory(t) { return new (t || NpnSliderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NpnSliderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NpnSliderComponent, selectors: [["npn-slider"]], hostBindings: function NpnSliderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseup", function NpnSliderComponent_mouseup_HostBindingHandler() { return ctx.setHandlerActiveOff(); }, false, ɵngcc0.ɵɵresolveDocument)("panend", function NpnSliderComponent_panend_HostBindingHandler() { return ctx.setHandlerActiveOff(); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { showStepIndicator: "showStepIndicator", multiRange: "multiRange", setMinValues: ["min", "setMinValues"], setMaxValues: ["max", "setMaxValues"], setMinSelectedValues: ["minSelected", "setMinSelectedValues"], setMaxSelectedValues: ["maxSelected", "setMaxSelectedValues"], stepValue: ["step", "stepValue"], setHideTooltip: ["hide-tooltip", "setHideTooltip"], setHideValues: ["hide-values", "setHideValues"], setDisabled: ["disabled", "setDisabled"] }, outputs: { onChange: "onChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 14, consts: [[1, "slider"], [1, "bar", 3, "mousemove", "panmove"], [1, "left-handle", 3, "ngClass", "mousedown", "panstart"], ["class", "handle-tooltip", 4, "ngIf"], [1, "filler"], [1, "step-indicators"], [3, "left", 4, "ngFor", "ngForOf"], [3, "left", "width", 4, "ngIf"], ["class", "right-handle", 3, "ngClass", "left", "mousedown", "panstart", 4, "ngIf"], ["class", "values", 4, "ngIf"], [1, "handle-tooltip"], [1, "right-handle", 3, "ngClass", "mousedown", "panstart"], [1, "values"]], template: function NpnSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("mousemove", function NpnSliderComponent_Template_div_mousemove_1_listener($event) { return ctx.handlerSliding($event); })("panmove", function NpnSliderComponent_Template_div_panmove_1_listener($event) { return ctx.handlerSliding($event); });
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵlistener("mousedown", function NpnSliderComponent_Template_span_mousedown_2_listener($event) { return ctx.setHandlerActive($event, ctx.handlerIndex.left); })("panstart", function NpnSliderComponent_Template_span_panstart_2_listener($event) { return ctx.setHandlerActive($event, ctx.handlerIndex.left); });
        ɵngcc0.ɵɵtemplate(3, NpnSliderComponent_span_3_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, NpnSliderComponent_span_6_Template, 1, 2, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, NpnSliderComponent_span_7_Template, 1, 4, "span", 7);
        ɵngcc0.ɵɵtemplate(8, NpnSliderComponent_span_8_Template, 1, 4, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NpnSliderComponent_span_9_Template, 2, 7, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, NpnSliderComponent_div_10_Template, 5, 2, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("left", ctx.handlerX[ctx.handlerIndex.left], "%");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c0, ctx.isHandlerActive && ctx.currentHandlerIndex === ctx.handlerIndex.left, ctx.currentHandlerIndex === ctx.handlerIndex.left));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideTooltip);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stepIndicatorPositions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiRange);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.multiRange);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiRange);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideValues);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgForOf], styles: [".slider[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}.slider[_ngcontent-%COMP%]{display:block;width:100%;height:30px;padding:4px 10px;cursor:default;font-size:12px}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]{width:100%;background:#e8e8e8;height:10px;position:relative;border-radius:5px;box-shadow:inset 1px 1px 5px #bababa}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]{display:inline-block;width:22px;height:22px;background:#bedcb2;border:7px solid #71b357;border-radius:50%;position:absolute;top:-7px;margin-left:-10px;z-index:1;cursor:pointer;transition:left .2s ease}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle.last-active[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle.last-active[_ngcontent-%COMP%]{z-index:2}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]{display:block;position:absolute;top:-34px;left:-14px;border:1px solid #8fc37a;border-radius:4px;padding:1px 4px;min-width:20px;text-align:center;background:#d9ebd2;color:#71b357;font-weight:700;transition:opacity .2s ease;opacity:0}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]:before, .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]:before{content:\"\";border:5px solid transparent;border-top-color:#8fc37a;position:absolute;top:104%;left:33%}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]:after, .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]:after{content:\"\";border:5px solid transparent;border-top-color:#d9ebd2;position:absolute;top:100%;left:33%}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle.active[_ngcontent-%COMP%] > .handle-tooltip[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%]:hover > .handle-tooltip[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle.active[_ngcontent-%COMP%] > .handle-tooltip[_ngcontent-%COMP%], .slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]:hover > .handle-tooltip[_ngcontent-%COMP%]{opacity:1}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]   div.filler[_ngcontent-%COMP%]{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px;border:1px solid #bedcb2}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]   div.filler[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:inline-block;height:100%;position:absolute;top:0;background:#bedcb2;transition:all .2s ease}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]   div.filler[_ngcontent-%COMP%] > div.step-indicators[_ngcontent-%COMP%]{width:100%;height:100%;position:relative}.slider[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]   div.filler[_ngcontent-%COMP%] > div.step-indicators[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{width:1px;display:inline-block;height:10px;background:#71b357;position:absolute;left:0}.slider[_ngcontent-%COMP%]   .values[_ngcontent-%COMP%]{display:block;font-weight:700;margin-top:4px;width:102%;margin-left:-1%;color:#908f90}.slider[_ngcontent-%COMP%]   .values[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{float:left}.slider[_ngcontent-%COMP%]   .values[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child{float:right}.slider.disabled[_ngcontent-%COMP%]{opacity:.4}.slider.disabled[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]{box-shadow:none!important}.slider.disabled[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%], .slider.disabled[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]{cursor:not-allowed}.slider.disabled[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.left-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%], .slider.disabled[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%] > span.right-handle[_ngcontent-%COMP%]   .handle-tooltip[_ngcontent-%COMP%]{display:none}"] });
/** @nocollapse */
NpnSliderComponent.ctorParameters = () => [
    { type: ElementRef }
];
NpnSliderComponent.propDecorators = {
    setMinValues: [{ type: Input, args: ['min',] }],
    setMaxValues: [{ type: Input, args: ['max',] }],
    setMinSelectedValues: [{ type: Input, args: ['minSelected',] }],
    setMaxSelectedValues: [{ type: Input, args: ['maxSelected',] }],
    stepValue: [{ type: Input, args: ['step',] }],
    showStepIndicator: [{ type: Input }],
    multiRange: [{ type: Input }],
    setHideTooltip: [{ type: Input, args: ['hide-tooltip',] }],
    setHideValues: [{ type: Input, args: ['hide-values',] }],
    setDisabled: [{ type: Input, args: ['disabled',] }],
    onChange: [{ type: Output }],
    setHandlerActiveOff: [{ type: HostListener, args: ['document:mouseup',] }, { type: HostListener, args: ['document:panend',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NpnSliderComponent, [{
        type: Component,
        args: [{
                selector: 'npn-slider',
                template: `<!--npn-slider template-->
<div class="slider" [class.disabled]="isDisabled">
  <div class="bar" (mousemove)="handlerSliding($event)" (panmove)="handlerSliding($event)">
    <span class="left-handle" [ngClass]="{'active': isHandlerActive && currentHandlerIndex === handlerIndex.left,
                      'last-active': currentHandlerIndex === handlerIndex.left
                    }"
      [style.left.%]="handlerX[handlerIndex.left]" (mousedown)="setHandlerActive($event, handlerIndex.left)" (panstart)="setHandlerActive($event, handlerIndex.left)">
      <span *ngIf="!hideTooltip" class="handle-tooltip">{{currentValues[handlerIndex.left]}}</span>
    </span>
    <div class="filler">
      <div class="step-indicators">
        <span *ngFor="let stepPos of stepIndicatorPositions" [style.left.px]="stepPos"></span>
      </div>
      <span *ngIf="multiRange" [style.left.%]="handlerX[0]" [style.width.%]="handlerX[handlerIndex.right] - handlerX[handlerIndex.left]"></span>
      <span *ngIf="!multiRange" [style.left.%]="0" [style.width.%]="handlerX[0]"></span>
    </div>
    <span *ngIf="multiRange" class="right-handle" [ngClass]="{'active': isHandlerActive && currentHandlerIndex === handlerIndex.right,
                      'last-active': currentHandlerIndex === handlerIndex.right
                    }"
      [style.left.%]="handlerX[handlerIndex.right]" (mousedown)="setHandlerActive($event, handlerIndex.right)"
      (panstart)="setHandlerActive($event, handlerIndex.right)">
      <span *ngIf="!hideTooltip" class="handle-tooltip">{{currentValues[handlerIndex.right]}}</span>
    </span>
  </div>
  <div class="values" *ngIf="!hideValues">
    <span>{{initValues[handlerIndex.left]}}</span>
    <span>{{initValues[handlerIndex.right]}}</span>
  </div>
</div>
`,
                styles: [`.slider,.slider *{box-sizing:border-box}.slider{display:block;width:100%;height:30px;padding:4px 10px;cursor:default;font-size:12px}.slider .bar{width:100%;background:#e8e8e8;height:10px;position:relative;border-radius:5px;box-shadow:inset 1px 1px 5px #bababa}.slider .bar>span.left-handle,.slider .bar>span.right-handle{display:inline-block;width:22px;height:22px;background:#bedcb2;border:7px solid #71b357;border-radius:50%;position:absolute;top:-7px;margin-left:-10px;z-index:1;cursor:pointer;transition:left .2s ease}.slider .bar>span.left-handle.last-active,.slider .bar>span.right-handle.last-active{z-index:2}.slider .bar>span.left-handle .handle-tooltip,.slider .bar>span.right-handle .handle-tooltip{display:block;position:absolute;top:-34px;left:-14px;border:1px solid #8fc37a;border-radius:4px;padding:1px 4px;min-width:20px;text-align:center;background:#d9ebd2;color:#71b357;font-weight:700;transition:opacity .2s ease;opacity:0}.slider .bar>span.left-handle .handle-tooltip:before,.slider .bar>span.right-handle .handle-tooltip:before{content:"";border:5px solid transparent;border-top-color:#8fc37a;position:absolute;top:104%;left:33%}.slider .bar>span.left-handle .handle-tooltip:after,.slider .bar>span.right-handle .handle-tooltip:after{content:"";border:5px solid transparent;border-top-color:#d9ebd2;position:absolute;top:100%;left:33%}.slider .bar>span.left-handle.active>.handle-tooltip,.slider .bar>span.left-handle:hover>.handle-tooltip,.slider .bar>span.right-handle.active>.handle-tooltip,.slider .bar>span.right-handle:hover>.handle-tooltip{opacity:1}.slider .bar div.filler{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px;border:1px solid #bedcb2}.slider .bar div.filler>span{display:inline-block;height:100%;position:absolute;top:0;background:#bedcb2;transition:all .2s ease}.slider .bar div.filler>div.step-indicators{width:100%;height:100%;position:relative}.slider .bar div.filler>div.step-indicators>span{width:1px;display:inline-block;height:10px;background:#71b357;position:absolute;left:0}.slider .values{display:block;font-weight:700;margin-top:4px;width:102%;margin-left:-1%;color:#908f90}.slider .values span:first-child{float:left}.slider .values span:last-child{float:right}.slider.disabled{opacity:.4}.slider.disabled .bar{box-shadow:none!important}.slider.disabled .bar>span.left-handle,.slider.disabled .bar>span.right-handle{cursor:not-allowed}.slider.disabled .bar>span.left-handle .handle-tooltip,.slider.disabled .bar>span.right-handle .handle-tooltip{display:none}`]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { showStepIndicator: [{
            type: Input
        }], multiRange: [{
            type: Input
        }], onChange: [{
            type: Output
        }], setMinValues: [{
            type: Input,
            args: ['min']
        }], setMaxValues: [{
            type: Input,
            args: ['max']
        }], setMinSelectedValues: [{
            type: Input,
            args: ['minSelected']
        }], setMaxSelectedValues: [{
            type: Input,
            args: ['maxSelected']
        }], stepValue: [{
            type: Input,
            args: ['step']
        }], setHideTooltip: [{
            type: Input,
            args: ['hide-tooltip']
        }], setHideValues: [{
            type: Input,
            args: ['hide-values']
        }], setDisabled: [{
            type: Input,
            args: ['disabled']
        }], 
    /**
     * @return {?}
     */
    setHandlerActiveOff: [{
            type: HostListener,
            args: ['document:mouseup']
        }, {
            type: HostListener,
            args: ['document:panend']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NpnSliderModule {
}
NpnSliderModule.ɵfac = function NpnSliderModule_Factory(t) { return new (t || NpnSliderModule)(); };
NpnSliderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NpnSliderModule });
NpnSliderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NpnSliderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [NpnSliderComponent],
                exports: [NpnSliderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NpnSliderModule, { declarations: function () { return [NpnSliderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NpnSliderComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NpnSliderComponent, NpnSliderModule, Utilities as ɵa };

